import React from 'react';
import QuestionExport from './QuestionExport';

const PageExport = ({page, items, parameters, extraFields}) => (
    <div className="pt-4">
        {page.items.map((q, index) => (
            <div key={index} className="mb-4">
                <QuestionExport question={q} items={items} parameters={parameters} extraFields={extraFields} />
            </div>
        ))}
    </div>
);

export default PageExport;
